import type { ModelChangedEventArgsInterface } from '@nts/std/interfaces';

export class ModelChangedEventArgs<TModel> implements ModelChangedEventArgsInterface<TModel> {
    senderName: string;
    model: TModel;
}
